import axios from "../../axios";
import { apiNews } from "../../axios/urlApi";

export const getNewsByID = (id) => {
  return axios.get(`${apiNews}/${id}` );
};
